export default __webpack_public_path__ + "media/images/wedding-a853ce457b01f13ddf42189df0b1b41a.png";